// extracted by mini-css-extract-plugin
export var completionBody = "_mq-2";
export var completionCard = "_mq-0";
export var completionFooter = "_mq-3";
export var completionTitle = "_mq-1";